import { useState, useEffect } from "react";
import { C, Input, Select, Btn } from "./ui";
import { proveedorService } from "../services/supabase";

const CAT_COLORS = {
  "Financiamiento": { bg:"#D0E4F4", tx:"#1E5080", ic:"💳" },
  "Veterinaria":    { bg:"#D4E8D4", tx:"#2D6E3A", ic:"🩺" },
  "Semillas":       { bg:"#FFF0C0", tx:"#7A5800", ic:"🌱" },
  "Maquinaria":     { bg:"#FAE0D0", tx:"#7A3020", ic:"🚜" },
  "Agroquímicos":   { bg:"#F0E4FA", tx:"#5A2080", ic:"🧪" },
  "Seguros":        { bg:"#E4EEF8", tx:"#2A4A6A", ic:"🛡" },
};

export function MarketplacePanel() {
  const [filtroCat, setFiltroCat] = useState("Todas");
  const [filtroLoc, setFiltroLoc] = useState("Todas");
  const [busqueda, setBusqueda] = useState("");
  const [proveedorSeleccionado, setProveedorSeleccionado] = useState(null);
  const [providers, setProviders] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    proveedorService.getAll()
      .then(setProviders)
      .catch(e => console.error("Error cargando proveedores:", e))
      .finally(() => setCargando(false));
  }, []);

  const CATEGORIAS = [...new Set(providers.map(p => p.cat).filter(Boolean))];
  const LOCALIDADES = ["Todas", ...new Set(providers.map(p => p.localidad).filter(Boolean))].sort();

  let filtrados = providers;
  if (filtroCat!=="Todas") filtrados = filtrados.filter(p=>p.cat===filtroCat);
  if (filtroLoc!=="Todas") filtrados = filtrados.filter(p=>p.localidad===filtroLoc);

  let productosEncontrados = [];
  if (busqueda) {
    const q = busqueda.toLowerCase();
    productosEncontrados = providers.flatMap(p => {
      const prods = (p.productos||[]).filter(prod => prod.nombre.toLowerCase().includes(q));
      return prods.map(prod => ({ ...prod, proveedor: p.nombre, proveedorId: p.id }));
    });
    filtrados = filtrados.filter(p=>
      (p.nombre||"").toLowerCase().includes(q) ||
      (p.desc||"").toLowerCase().includes(q) ||
      (p.cat||"").toLowerCase().includes(q)
    );
  }

  if (proveedorSeleccionado) {
    const p = proveedorSeleccionado;
    const c = CAT_COLORS[p.cat] || { bg: C.arena, tx: C.muted, ic: "🏢" };
    return (
      <div style={{ flex: 1, overflowY: "auto", background: C.fondo }}>
        <div style={{ padding: "20px 24px", maxWidth: 900, margin: "0 auto" }}>
          <Btn variant="secondary" onClick={() => setProveedorSeleccionado(null)} style={{ marginBottom: 16 }}>
            ← Volver al directorio
          </Btn>

          <div style={{ background: C.white, borderRadius: 12, padding: 20, border: `2px solid ${c.bg}`, marginBottom: 20 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
              <span style={{ fontSize: 40 }}>{c.ic}</span>
              <div>
                <div style={{ fontFamily: "serif", fontSize: 28, fontWeight: 700, color: C.tierra }}>{p.nombre}</div>
                <div style={{ fontSize: 13, color: C.muted }}>{p.cat} · {p.localidad}</div>
              </div>
            </div>

            <div style={{ fontSize: 14, color: C.texto, lineHeight: 1.8, marginBottom: 20 }}>
              {p.desc}
            </div>

            <div style={{ display: "flex", gap: 16, flexWrap: "wrap", paddingTop: 12, borderTop: `1px solid ${C.arenaDark}` }}>
              <a href={`tel:${p.tel.replace(/\s/g,"")}`} style={{ fontSize: 13, color: C.pasto, textDecoration: "none", fontFamily: "monospace" }}>
                📞 {p.tel}
              </a>
              <a href={`https://${p.web}`} target="_blank" rel="noreferrer"
                style={{ fontSize: 13, color: C.pastoLight, textDecoration: "none" }}>
                🌐 {p.web}
              </a>
            </div>
          </div>

          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 18, fontWeight: 600, color: C.tierra, marginBottom: 12 }}>📦 Catálogo de productos</div>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: 12 }}>
              {(p.productos || []).map((prod, idx) => (
                <div key={idx} style={{ background: C.white, borderRadius: 10, padding: "12px 14px", border: `1px solid ${C.arenaDark}` }}>
                  <div style={{ fontWeight: 600, fontSize: 13, color: C.tierra }}>{prod.nombre}</div>
                  <div style={{ fontSize: 12, color: C.muted, marginTop: 6 }}>{prod.precio} / {prod.unidad}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ flex:1, overflowY:"auto", background:C.fondo }}>
      <div style={{ padding:"20px 24px" }}>
        <div style={{ marginBottom:20 }}>
          <div style={{ fontFamily:"serif", fontSize:22, color:C.tierra, fontWeight:600, marginBottom:4 }}>Proveedores y Servicios</div>
          <div style={{ fontSize:13, color:C.muted }}>Directorio de empresas del sector agropecuario uruguayo</div>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"2fr 1fr", gap:12, marginBottom:16 }}>
          <Input label="Buscar proveedor o producto" value={busqueda} onChange={setBusqueda} placeholder="Semillas, vacunas, maquinaria..."/>
          <Select label="Localidad" value={filtroLoc} onChange={setFiltroLoc} options={LOCALIDADES}/>
        </div>

        <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:16 }}>
          {["Todas",...CATEGORIAS].map(cat=>{
            const style = CAT_COLORS[cat];
            return (
              <button key={cat} onClick={()=>setFiltroCat(cat)} style={{
                padding:"5px 12px", fontSize:11, fontFamily:"monospace", border:"none", cursor:"pointer",
                borderRadius:16, transition:"all 0.15s",
                background: filtroCat===cat ? (style?.bg||C.pasto) : C.arena,
                color:       filtroCat===cat ? (style?.tx||"white") : C.muted,
                fontWeight:  filtroCat===cat ? 600 : 400,
              }}>{cat}</button>
            );
          })}
        </div>

        {productosEncontrados.length > 0 && (
          <div style={{ marginBottom:20 }}>
            <div style={{ fontSize:13, fontFamily:"monospace", textTransform:"uppercase", color:C.muted, marginBottom:10, fontWeight:600 }}>
              🔍 Resultados de productos · {productosEncontrados.length}
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(280px, 1fr))", gap:10 }}>
              {productosEncontrados.map((prod, idx) => (
                <div key={idx} style={{ background:C.white, borderRadius:10, padding:"12px 14px",
                  border:`1px solid ${C.arenaDark}`, display:"flex", flexDirection:"column", gap:6 }}>
                  <div style={{ fontWeight:600, fontSize:13, color:C.tierra }}>{prod.nombre}</div>
                  <div style={{ fontSize:12, color:C.muted, display:"flex", gap:8, alignItems:"center" }}>
                    <span>{prod.precio} / {prod.unidad}</span>
                  </div>
                  <div style={{ fontSize:11, color:C.pasto, fontFamily:"monospace" }}>📦 Vendido por: {prod.proveedor}</div>
                </div>
              ))}
            </div>
            <div style={{ height:1, background:C.arenaDark, margin:"20px 0" }}/>
          </div>
        )}

        {cargando && (
          <div style={{ textAlign:"center", padding:"40px", color:C.muted, fontSize:13 }}>Cargando proveedores…</div>
        )}
        {!cargando && providers.length === 0 && (
          <div style={{ textAlign:"center", padding:"40px 20px", color:C.muted }}>
            <div style={{ fontSize:36, marginBottom:10 }}>🏪</div>
            <div style={{ fontSize:13 }}>No hay proveedores cargados todavía.</div>
          </div>
        )}

        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(300px, 1fr))", gap:14 }}>
          {filtrados.map(p=>{
            const c = CAT_COLORS[p.cat]||{ bg:C.arena, tx:C.muted, ic:"🏢" };
            return (
              <div key={p.id} onClick={() => setProveedorSeleccionado(p)}
                style={{ background:C.white, borderRadius:12, padding:"16px 18px",
                border:`1.5px solid ${C.arenaDark}`, display:"flex", flexDirection:"column", gap:10,
                cursor:"pointer", transition:"all 0.15s", hover:{boxShadow:`0 4px 12px rgba(0,0,0,0.1)`} }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
                  <div style={{ fontFamily:"serif", fontSize:16, fontWeight:600, color:C.tierra }}>{p.nombre}</div>
                  <span style={{ fontSize:10, fontFamily:"monospace", padding:"3px 8px", borderRadius:12,
                    background:c.bg, color:c.tx, whiteSpace:"nowrap" }}>
                    {c.ic} {p.cat}
                  </span>
                </div>
                <div style={{ fontSize:12, color:C.muted, lineHeight:1.6 }}>{p.desc}</div>
                {(p.productos || []).length > 0 && (
                  <div style={{ fontSize:11, color:C.pasto, fontFamily:"monospace" }}>
                    📦 {(p.productos || []).length} productos disponibles
                  </div>
                )}
                <div style={{ display:"flex", gap:8, marginTop:"auto", paddingTop:4, borderTop:`1px solid ${C.arenaDark}`, flexWrap:"wrap" }}>
                  <a href={`tel:${p.tel.replace(/\s/g,"")}`} onClick={(e) => e.stopPropagation()}
                    style={{ fontSize:11, color:C.pasto, textDecoration:"none", fontFamily:"monospace" }}>
                    📞 {p.tel}
                  </a>
                  <a href={`https://${p.web}`} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}
                    style={{ fontSize:11, color:C.pastoLight, textDecoration:"none", marginLeft:"auto" }}>
                    🌐 {p.web}
                  </a>
                </div>
              </div>
            );
          })}
        </div>

        <div style={{ textAlign:"center", marginTop:28, padding:"14px 20px",
          background:C.arena, borderRadius:10, fontSize:12, color:C.muted }}>
          ¿Tu empresa quiere aparecer aquí? · contacto@campoia.uy
        </div>
      </div>
    </div>
  );
}
